import * as Yup from "yup";

export const perfilAccsessSchema = Yup.object().shape({
  name: Yup.string().required("Por favor, insira um nome."),
});
